import React from 'react';
import PropTypes from 'prop-types';
import { Nav, NavLink, TabContent, TabPane } from 'reactstrap';
import cn from 'classnames';
import { injectIntl } from 'react-intl';

// Components
import Service from 'components/atoms/Service';
import Button from 'components/atoms/Button';
import Price from 'components/atoms/Price';
import Spinner from 'components/atoms/Spinner';

// Constants
import { SERVICES_TYPE } from 'constants/services';

import './PackagesTableMobile.scss';

const ns = 'packages-table-mobile';
const { MENU } = SERVICES_TYPE;

const PackagesTableMobile = ({
  packages,
  selectService,
  selectedPackage,
  addPackage,
  activeTab,
  toggleActiveTab,
  canUpdate,
  intl,
  readOnly,
  quoteServices
}) => {
  const getButtonContent = isSelected => {
    if (isSelected && !canUpdate) {
      return intl.formatMessage({
        id: 'c8.services.page.packages.modal.button.remove'
      });
    } else if (isSelected && canUpdate) {
      return intl.formatMessage({
        id: 'c8.services.page.packages.modal.button.update'
      });
    } else {
      return intl.formatMessage({
        id: 'c8.services.page.packages.modal.button.add'
      });
    }
  };

  return (
    <div className={ns}>
      <Nav
        className={`${ns}__header ${ns}__nav d-flex flex-row flex-nowrap`}
        tabs
      >
        {packages.map(pack => {
          const tabName = pack.description;
          return (
            <NavLink
              key={tabName}
              onClick={() => toggleActiveTab(tabName)}
              className={cn(`${ns}__nav-tab`, 'flex-shrink-0', {
                [`${ns}__nav-tab--active`]: activeTab === tabName
              })}
            >
              {tabName}
            </NavLink>
          );
        })}
      </Nav>

      <div className={`${ns}__body d-flex`}>
        <TabContent className={`d-block`} activeTab={activeTab}>
          <TabPane tabId={'spinner'} className={`${ns}__spinner-container `}>
            <Spinner />
          </TabPane>
          {packages.map((pack, index) => {
            const tabName = pack.description;
            const footerClassName = cn(`${ns}__footer`, {
              [`${ns}__footer--disabled`]:
                pack.services.reduce((a, b) => a + b.isSelected, 0) < 1
            });
            const isPackageSelected = selectedPackage === pack.description;
            const buttonClassName = cn(`${ns}__continue-button`, 'text-right', {
              [`${ns}__continue-button--remove`]: isPackageSelected
            });
            const optionalServices = pack.services.filter(
              service => service.selectable
            );
            const includedServices = pack.services.filter(
              service => !service.selectable
            );
            return (
              <TabPane key={tabName} tabId={tabName}>
                {includedServices.length > 0 && (
                  <div>
                    <div className={`${ns}__label`}>
                      {intl.formatMessage({
                        id:
                          'c8.services.page.packages.modal.label.included.services'
                      })}
                    </div>
                    <div className={`${ns}__service-list`}>
                      {includedServices.map(service => {
                        const isQuoteService =
                          quoteServices &&
                          quoteServices.find(
                            quoteService => quoteService.id === service.id
                          );
                        return (
                          <Service
                            key={service.id}
                            service={service}
                            onSelect={() => selectService(service.id, index)}
                            isSelected={service.isSelected}
                            isOptional={false}
                            readOnly={
                              readOnly &&
                              isQuoteService &&
                              isQuoteService.selectByDefault
                            }
                          />
                        );
                      })}
                    </div>
                  </div>
                )}
                {optionalServices.length > 0 && (
                  <div>
                    <div className={`${ns}__label`}>
                      {intl.formatMessage({
                        id:
                          'c8.services.page.packages.modal.label.optional.services'
                      })}
                    </div>
                    <div className={`${ns}__service-list`}>
                      {optionalServices.map(service => {
                        const isQuoteService =
                          quoteServices &&
                          quoteServices.find(
                            quoteService => quoteService.id === service.id
                          );
                        return (
                          <Service
                            key={service.id}
                            service={service}
                            onSelect={() => selectService(service.id, index)}
                            isSelected={service.isSelected}
                            promotion={service.promotion}
                            readOnly={
                              readOnly &&
                              isQuoteService &&
                              isQuoteService.selectByDefault
                            }
                          />
                        );
                      })}
                    </div>
                  </div>
                )}
                <div className={footerClassName}>
                  <Button
                    buttonTheme="link"
                    className={buttonClassName}
                    disabled={
                      pack.services.reduce((a, b) => a + b.isSelected, 0) < 1 ||
                      (readOnly && !canUpdate)
                    }
                    onClick={() => addPackage(pack)}
                  >
                    <div className={`${ns}__price`}>
                      {!isPackageSelected &&
                        pack.showPrice && (
                          <Price value={pack.price} type={MENU} />
                        )}
                    </div>
                    {getButtonContent(isPackageSelected)}
                  </Button>
                </div>
              </TabPane>
            );
          })}
        </TabContent>
      </div>
    </div>
  );
};

PackagesTableMobile.propTypes = {
  activeTab: PropTypes.string,
  addPackage: PropTypes.func.isRequired,
  canUpdate: PropTypes.bool,
  intl: PropTypes.object,
  packages: PropTypes.array.isRequired,
  selectedPackage: PropTypes.string,
  selectService: PropTypes.func.isRequired,
  toggleActiveTab: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  quoteServices: PropTypes.array
};

export default injectIntl(PackagesTableMobile);



// WEBPACK FOOTER //
// ./src/components/molecules/PackagesTableMobile/PackagesTableMobile.js